import Loading from '../../../Common/Loading';
import { useProfileChartsDataContext } from './hooks/useProfileChartsDataContext';
import { OcurrenceByLocalAndGender } from './OcurrenceListByLocalAndGender';
import { OcurrencesByGenderAnually } from './OcurrencesByGenderAnually';
import { OcurrencesByGenderMonthly } from './OcurrencesByGenderMonthly';
import './styles/Charts.css';

export const Charts = () => {
    const { isLoading } = useProfileChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <OcurrenceByLocalAndGender />
            <div className="charts-side-by-side-dashboards">
                <OcurrencesByGenderAnually />
                <OcurrencesByGenderMonthly />
            </div>
        </>
    );
};
